import React, { Fragment, useEffect, useState } from 'react'
// import cx from '../../styles';
import { configFetch, dataSharingInfo, confirmDataSharing } from '../../actions/index';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import UserDataSharingModal from '../Common/UserDataSharingModal';

const DataSharing = (props) => {
    const [permissionInfo, setPermissionInfo] = useState({});
    const [showPopup, setShowPopup] = useState(false);
    useEffect(()=>{
        props.configFetch()
        .then((res)=>{
            if(res && res.data_sharing && res.data_sharing.is_enabled && res.data_sharing.is_enabled === -1){
                props.dataSharingInfo()
                .then((res)=>{
                    if(res && res.start_data_sharing){
                        setPermissionInfo(res.start_data_sharing)
                        setShowPopup(true)
                    }
                })
            }
        })
    },[])

    const togglePopup = () => {
        setShowPopup(false);
    }

    const confirmDataSharing = (setting_data_sharing) => {
        props.confirmDataSharing(setting_data_sharing)
    }

    return (
        <Fragment>
            <UserDataSharingModal 
                dataSharing={true} 
                showPopup={showPopup} 
                permissionInfo={permissionInfo} 
                togglePopup={togglePopup}
                confirmDataSharing={confirmDataSharing}
            />
        </Fragment>
    );
}

//map state
const mapStateToProps = (state) => {
    return state;
}

//map dispatch
const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        configFetch,
        dataSharingInfo,
        confirmDataSharing
    }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(DataSharing);